import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "tx-pagehead" }
const _hoisted_2 = {
  class: "tx-seg tx-mb",
  role: "tablist"
}
const _hoisted_3 = ["aria-selected", "onClick"]
const _hoisted_4 = {
  key: 0,
  class: "tx-cards"
}
const _hoisted_5 = {
  key: 0,
  class: "tx-eyebrow"
}
const _hoisted_6 = {
  key: 1,
  class: "tx-muted"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "tx-card tx-card--flush"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "tx-row__main" }
const _hoisted_11 = {
  key: 2,
  class: "tx-card tx-card--flush"
}
const _hoisted_12 = {
  key: 1,
  class: "tx-table"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", null, "#", -1 /* HOISTED */)
const _hoisted_14 = { class: "tx-mono" }
const _hoisted_15 = ["onSubmit"]
const _hoisted_16 = {
  key: 0,
  class: "tx-muted"
}
const _hoisted_17 = { class: "tx-field" }
const _hoisted_18 = { class: "tx-field" }
const _hoisted_19 = { class: "tx-formrow" }
const _hoisted_20 = { class: "tx-field" }
const _hoisted_21 = {
  key: 0,
  class: "tx-field"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "—", -1 /* HOISTED */)
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "tx-formactions" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "tx-card tx-modal__body" }
const _hoisted_27 = { class: "tx-card__head" }
const _hoisted_28 = { class: "tx-muted" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = ["href"]
const _hoisted_32 = { class: "tx-formactions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString($setup.state.t("services.title")), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabs, (tb) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tb.id,
          role: "tab",
          "aria-selected": $setup.tab === tb.id,
          class: _normalizeClass({ on: $setup.tab === tb.id }),
          onClick: $event => ($setup.tab = tb.id)
        }, _toDisplayString($setup.state.t(tb.label)), 11 /* TEXT, CLASS, PROPS */, _hoisted_3))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode($setup["Loader"], {
      loading: $setup.loading,
      error: $setup.error,
      onRetry: $setup.load
    }, {
      default: _withCtx(() => [
        ($setup.tab === 'catalogue')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (!$setup.catalogue.length)
                ? (_openBlock(), _createBlock($setup["Empty"], {
                    key: 0,
                    icon: "grid"
                  }))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.catalogue, (s) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: s.name,
                  class: "tx-card tx-svc"
                }, [
                  (s.category)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(s.category), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("strong", null, _toDisplayString(s.name), 1 /* TEXT */),
                  _createElementVNode("p", null, _toDisplayString(s.description), 1 /* TEXT */),
                  (s.response_target)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(s.response_target), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("button", {
                    class: "tx-btn tx-btn--primary tx-btn--sm",
                    onClick: $event => ($setup.openForm(s))
                  }, _toDisplayString($setup.state.t("services.request")), 9 /* TEXT, PROPS */, _hoisted_7)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : ($setup.tab === 'requests')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (!$setup.requests.length)
                  ? (_openBlock(), _createBlock($setup["Empty"], {
                      key: 0,
                      icon: "grid"
                    }))
                  : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.requests, (r) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: r.name,
                    class: "tx-row tx-row--btn",
                    onClick: $event => ($setup.openRequest(r))
                  }, [
                    _createElementVNode("span", _hoisted_10, [
                      _createElementVNode("strong", null, _toDisplayString(r.subject), 1 /* TEXT */),
                      _createElementVNode("small", null, [
                        _createTextVNode(_toDisplayString(r.name) + " · " + _toDisplayString(r.service || "") + " · " + _toDisplayString($setup.fmtDate(r.modified, true)) + " ", 1 /* TEXT */),
                        (r.helpdesk_ticket)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" · #" + _toDisplayString(r.helpdesk_ticket), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _createVNode($setup["Badge"], {
                      status: r.status
                    }, null, 8 /* PROPS */, ["status"])
                  ], 8 /* PROPS */, _hoisted_9))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (!$setup.subs.length)
                  ? (_openBlock(), _createBlock($setup["Empty"], {
                      key: 0,
                      icon: "file"
                    }))
                  : (_openBlock(), _createElementBlock("table", _hoisted_12, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_13,
                          _createElementVNode("th", null, _toDisplayString($setup.state.t("services.plans")), 1 /* TEXT */),
                          _createElementVNode("th", null, _toDisplayString($setup.state.t("services.ends")), 1 /* TEXT */),
                          _createElementVNode("th", null, _toDisplayString($setup.state.t("common.status")), 1 /* TEXT */)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.subs, (s) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: s.name
                          }, [
                            _createElementVNode("td", _hoisted_14, _toDisplayString(s.name), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(s.plans.map((p) => `${p.plan} × ${p.qty}`).join(", ")), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString($setup.fmtDate(s.end_date || s.current_invoice_end)), 1 /* TEXT */),
                            _createElementVNode("td", null, [
                              _createVNode($setup["Badge"], {
                                status: s.status
                              }, null, 8 /* PROPS */, ["status"])
                            ])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]))
              ]))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["loading", "error"]),
    ($setup.form)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "tx-modal",
          role: "dialog",
          "aria-modal": "true",
          onClick: _cache[5] || (_cache[5] = _withModifiers($event => ($setup.form = null), ["self"]))
        }, [
          _createElementVNode("form", {
            class: "tx-card tx-form tx-modal__body",
            onSubmit: _withModifiers($setup.submit, ["prevent"])
          }, [
            _createElementVNode("h2", null, _toDisplayString($setup.form.service.name), 1 /* TEXT */),
            ($setup.form.service.instructions)
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString($setup.form.service.instructions), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("label", _hoisted_17, [
              _createElementVNode("span", null, _toDisplayString($setup.state.t("tickets.subject")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.form.subject) = $event)),
                required: "",
                minlength: "3",
                maxlength: "140"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.form.subject]
              ])
            ]),
            _createElementVNode("label", _hoisted_18, [
              _createElementVNode("span", null, _toDisplayString($setup.state.t("services.details")), 1 /* TEXT */),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.form.details) = $event)),
                rows: "5",
                required: "",
                maxlength: "20000"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.form.details]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, [
                _createElementVNode("span", null, _toDisplayString($setup.state.t("services.priority")), 1 /* TEXT */),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.form.priority) = $event))
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Low', 'Medium', 'High', 'Urgent'], (p) => {
                    return _createElementVNode("option", { key: p }, _toDisplayString(p), 1 /* TEXT */)
                  }), 64 /* STABLE_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, $setup.form.priority]
                ])
              ]),
              ($setup.refOptions.length)
                ? (_openBlock(), _createElementBlock("label", _hoisted_21, [
                    _createElementVNode("span", null, _toDisplayString($setup.state.t("services.related")) + " (" + _toDisplayString($setup.state.t("common.optional")) + ")", 1 /* TEXT */),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.form.ref) = $event))
                    }, [
                      _hoisted_22,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.refOptions, (o) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: o.value,
                          value: o.value
                        }, _toDisplayString(o.label), 9 /* TEXT, PROPS */, _hoisted_23))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, $setup.form.ref]
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                type: "button",
                class: "tx-btn tx-btn--ghost",
                onClick: _cache[4] || (_cache[4] = $event => ($setup.form = null))
              }, _toDisplayString($setup.state.t("common.cancel")), 1 /* TEXT */),
              _createElementVNode("button", {
                class: "tx-btn tx-btn--primary",
                disabled: $setup.busy
              }, _toDisplayString($setup.state.t("common.submit")), 9 /* TEXT, PROPS */, _hoisted_25)
            ])
          ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_15)
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.viewing)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "tx-modal",
          role: "dialog",
          "aria-modal": "true",
          onClick: _cache[7] || (_cache[7] = _withModifiers($event => ($setup.viewing = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("h2", null, _toDisplayString($setup.viewing.subject), 1 /* TEXT */),
              _createVNode($setup["Badge"], {
                status: $setup.viewing.status
              }, null, 8 /* PROPS */, ["status"])
            ]),
            _createElementVNode("small", _hoisted_28, _toDisplayString($setup.viewing.name) + " · " + _toDisplayString($setup.fmtDate($setup.viewing.creation, true)), 1 /* TEXT */),
            _createElementVNode("div", {
              class: "tx-prose",
              innerHTML: $setup.viewing.details
            }, null, 8 /* PROPS */, _hoisted_29),
            ($setup.viewing.customer_response)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("h3", null, _toDisplayString($setup.state.t("services.response")), 1 /* TEXT */),
                  _createElementVNode("div", {
                    class: "tx-prose tx-quote",
                    innerHTML: $setup.viewing.customer_response
                  }, null, 8 /* PROPS */, _hoisted_30)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            ($setup.viewing.helpdesk_ticket)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: $setup.link('tickets/' + $setup.viewing.helpdesk_ticket),
                  "data-nav": "",
                  class: "tx-link"
                }, "#" + _toDisplayString($setup.viewing.helpdesk_ticket), 9 /* TEXT, PROPS */, _hoisted_31))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                class: "tx-btn tx-btn--ghost",
                onClick: _cache[6] || (_cache[6] = $event => ($setup.viewing = null))
              }, _toDisplayString($setup.state.t("common.close")), 1 /* TEXT */)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}